<template>
    <div class="configurator-select-checkbox" v-bind:id="groupId">
        <accordion :show="true">
            <div slot="header">{{ title }}</div>

            <div class="row">

                <div v-for="(item, index) in options" class="col-md-6 col-xl-4 mb-4">
                    <div :class="'select-checkbox-' + groupId" class="select-checkbox-container" :id="'container_' + changeString(item.Name)">

                        <div class="form-check">
                            <label class="form-check-label">
                                <input class="form-check-input" type="checkbox" :id="changeString(characteristic+'-'+item.Name)" v-on:click="onSelect(item.Name, characteristic)" :checked="item.Selected">
                                <span class="form-check-sign">
                                    <span class="check"></span>
                                </span>
                            </label>
                        </div>

                        <br/>

                        <div class="select-checkbox-title mt-4">{{ item.Description }}
                            <span v-if="item.Price" style="font-weight: 500;">(+&nbsp;{{ formatPrice(item.Price) }})</span></div>
                        <div v-if="item.InfoText && item.InfoText.length > 220" class="select-checkbox-text read-more-text">{{ item.InfoText }}</div>
                        <div v-if="item.InfoText && item.InfoText.length < 220" class="select-checkbox-text">{{ item.InfoText }}</div>

                        <div class="select-checkbox-action-container">
                            <a href="#" :ref="'readMore_' + item.Name" class="select-checkbox-read-more" v-if="item.InfoText && item.InfoText.length > 220" v-on:click="toggleRead($event, 'more', item.Name)">Mehr anzeigen <i class="fas fa-angle-down"></i></a>
                            <a href="#" :ref="'readLess_' + item.Name" class="select-checkbox-read-less" v-if="item.InfoText " v-on:click="toggleRead($event, 'less', item.Name)">Weniger anzeigen <i class="fas fa-angle-up"></i></a>
                        </div>

                        <div class="select-checkbox-image" v-if="item.InfoImage">

                            <v-lazy-image :src="item.InfoImage" />
                        </div>
                    </div>
                </div>
            </div>
        </accordion>
    </div>
</template>

<script>
    import VLazyImage from "v-lazy-image";

    export default {
        name: 'SelectCombobox',
        props: {
            title: String,
            characteristic: String,
            options: Array
        },
        components: {
            VLazyImage
        },
        computed: {
            groupId() {
                return this.title.replace(/ /gi, "_")
            }
        },
        methods: {
            formatPrice(value) {

                let val = (value/1).toFixed(2).replace('.', ',');
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + ' ' + this.$parent.$parent.priceSymbol;
            },
            changeString(value) {
                value = value.toLowerCase();
                value = value.replace(/ä/g, 'ae');
                value = value.replace(/ö/g, 'oe');
                value = value.replace(/ü/g, 'ue');
                value = value.replace(/ß/g, 'ss');
                value = value.replace(/ /g, '-');
                value = value.replace(/\./g, '');
                value = value.replace(/,/g, '');
                value = value.replace(/\(/g, '');
                value = value.replace(/\)/g, '');
                value = value.replace('/', '-');
                return value;
            },
            toggleRead: function(event, state, category) {
                event.preventDefault();

                if(state === "more") {
                    let readMore = this.$refs['readMore_' + category];
                    $(readMore).hide();
                    $(readMore).parent().siblings('.select-checkbox-text').css( { 'height':'auto', 'max-height':'300px', 'overflow-y': 'auto' } );
                    $(readMore).siblings('.select-checkbox-read-less').show();
                } else if(state === "less") {
                    let readLess = this.$refs['readLess_' + category];
                    $(readLess).hide();
                    $(readLess).parent().siblings('.select-checkbox-text').css( { 'height':'85px', 'margin-bottom': '0', 'overflow-y': 'hidden' } );
                    $(readLess).siblings('.select-checkbox-read-more').show();
                }
            },
            onSelect: function(data, characteristic) {
                let app = this;
                let parent = app.$parent;
                this.$parent.popupError = false;

                let params = new URLSearchParams();
                params.append('apikey', this.$apikey);
                params.append('apipassword', this.$apipassword);
                params.append('ConfigurationID', parent.$parent.ConfigurationID);
                params.append('Characteristic', characteristic);
                params.append('Value', data);
                params.append('Accessories', true);
                params.append('CustomerID', parent.$parent.customerID);

                let selectCombobox = $('.select-checkbox-' + app.groupId);
                selectCombobox.css('opacity', '0.5');

                parent.$parent.loading = true;

                let selectContainer = 'container_' + this.changeString(data);
                selectContainer = $('#'+selectContainer);

                if(selectContainer.hasClass('active')) {
                    selectContainer.removeClass('active');
                } else {
                    selectContainer.addClass('active');
                }

                app.$http.post(this.$apiurl + '/api/SetValue', params)
                    .then(response => {
                        selectCombobox.css('opacity', '1');
                        if(response.data['TransferData']['Price']) parent.$parent.price = response.data['TransferData']['Price'].toFixed(2).replace('.', ',') + ' ' + parent.$parent.priceSymbol;
                        parent.$parent.loading = false;

                        if(response.data['TransferData']['ConfigurationID']) {
                            parent.$parent.ConfigurationID = response.data['TransferData']['ConfigurationID'];
                        }
                    })
                    .catch(error => {
                        parent.$parent.popupError = true;
                    })
            }
        },
        mounted() {
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .configurator-select-checkbox >>> .body-inner {
        margin-top: 30px;
    }
    .configurator-select-checkbox .select-checkbox-container {
        border: 2px solid #afb0af;
        background: #ffffff;
        position: relative;
        height: 100%;
        overflow: hidden;
        padding: 30px;
        margin-bottom: 20px;
        font-size: 15px;
    }
    .configurator-select-checkbox .select-checkbox-container.active {
        border-color: #ec7205;
    }
    .configurator-select-checkbox .select-checkbox-container .select-checkbox-title {
        font-weight: bold;
        text-transform: uppercase;
    }
    .configurator-select-checkbox .select-checkbox-container .select-checkbox-text {
        font-size: 13px;
        line-height: 1.6;
        font-weight: 500;
        background: #ffffff;
        overflow: hidden;
        position: relative;
        z-index: 1;
        -webkit-transition: all 0.3s ease;
        -moz-transition: all 0.3s ease;
        -o-transition: all 0.3s ease;
        -ms-transition: all 0.3s ease;
        transition: all 0.3s ease ;
    }
    .configurator-select-checkbox .select-checkbox-container .select-checkbox-text.read-more-text {
        height: 85px;
    }
    .configurator-select-checkbox .select-checkbox-container .select-checkbox-price {
        font-weight: 500;
    }
    .configurator-select-checkbox .select-checkbox-action-container {
        text-align: center;
        margin-top: 25px;
        margin-bottom: 15px;
    }
    .configurator-select-checkbox .select-checkbox-read-less {
        display: none;
        z-index: 1;
        font-family: Roboto Slab;
        font-size: 11px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.64;
        letter-spacing: 0.46px;
        text-transform: uppercase;
        color: #131313;
    }
    .configurator-select-checkbox .select-checkbox-read-less i {
        font-size: 16px;
        margin-left: 5px;
    }
    .configurator-select-checkbox .select-checkbox-read-more {
        font-family: Roboto Slab;
        font-size: 11px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.64;
        letter-spacing: 0.46px;
        text-transform: uppercase;
        color: #131313;
    }
    .configurator-select-checkbox .select-checkbox-read-more i {
        font-size: 16px;
        margin-left: 5px;
    }
    .configurator-select-checkbox .select-checkbox-container .select-checkbox-image {
        position: relative;
        z-index: 0;
    }
    .configurator-select-checkbox .select-checkbox-container .select-checkbox-image img {
        width: 100%;
    }
    .configurator-select-checkbox .select-checkbox-container .form-check .form-check-sign:hover .check:before {
        color: #ec7205;
    }
    .configurator-select-checkbox .select-checkbox-container .form-check .form-check-sign .check:before {
        color: #cccccc;
        box-shadow: 0 0 0 10px,
        10px -10px 0 10px,
        32px 0 0 20px,
        0px 32px 0 20px,
        -5px 5px 0 10px,
        20px -12px 0 11px;
        -webkit-animation: checkbox-on 0.3s forwards;
        -moz-animation: checkbox-on 0.3s forwards;
        -o-animation: checkbox-on 0.3s forwards;
        -ms-animation: checkbox-on 0.3s forwards;
        animation: checkbox-on 0.3s forwards;
    }
    .configurator-select-checkbox .select-checkbox-container .form-check .form-check-input:checked + .form-check-sign .check:before {
        color: #ec7205;
    }
    .v-lazy-image {
        opacity: 0;
        transition: opacity 2s;
    }
    .v-lazy-image-loaded {
        opacity: 1;
    }
</style>